$(".check_radio_0").on("click", function () {
  let personalization_tag = $("#tags_value").val();
  console.log(personalization_tag, "-------personalization_tag");

  if ($(this).val() == "yes") {
    $(".additional_infomation_txt").removeClass("hide");
    $(".city_state1").removeClass("hide");
    if ($("#tags").length === 0) {
      html = `<input type="hidden" id="tags" name="properties[_personalization]" value="${personalization_tag}">`;
      $(".hidden_properties").before(html);
    }
    if (
      $("#additional_info").length === 0 &&
      $(".additional_infomation_txt").length > 0
    ) {
      html = `<input type="hidden" name="properties[Additional Info]" value="" id="additional_info">`;
      $(".hidden_properties").before(html);
    }

    if ($("#additional_info1").length === 0 && $(".city_state1").length > 0) {
      var html1 = `<input type="hidden" name="properties[City and State - 1]" value="" id="additional_info1">`;
      $(".hidden_properties").before(html1);
    }
    $(".customizations_div").removeClass("hide");
  } else {
    $(".additional_infomation_txt").addClass("hide");
    $(".city_state1").addClass("hide");
    $("#tags").remove();
    $("#additional_info1").remove();
    $("#additional_info2").remove();
    $("#additional_info3").remove();
    $("#additional_info4").remove();
    $("#additional_info5").remove();
    $("#additional_info6").remove();
    $("#additional_info7").remove();
    $("#additional_info8").remove();
    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info15").remove();

    $(".customizations_div").addClass("hide");
    $("#customization_1").remove();
    $("#customization_2").remove();
    $("#customization_3").remove();

    $("#customization_img_1").remove();
    $("#customization_img_2").remove();
    $("#customization_img_3").remove();

    $("#customization_imgText_1").remove();
    $("#customization_imgText_2").remove();
    $("#customization_imgText_3").remove();

    $("#custom_text_map1").remove();
    $("#custom_text_map2").remove();
    $("#custom_text_map3").remove();

    $("#custom_text1").remove();
    $("#custom_text2").remove();
    $("#custom_text3").remove();

    $("#customization_text_4").remove();
    $("#customization_text_5").remove();
    $("#customization_text_6").remove();
    $("#customization_text_7").remove();
    $("#customization_text_8").remove();
    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
});

$(".check_radio_1").on("click", function () {
  if ($(this).val() == "yes") {
    $(".city_state2").removeClass("hide");
    $("#ProofWrapper2").removeClass("hide");
    if ($("#additional_info2").length === 0 && $(".city_state2").length > 0) {
      var html = `<input type="hidden" name="properties[City and State - 2]" value="" id="additional_info2">`;
      $(".hidden_properties").before(html);
    }
  } else {
    $(".city_state2").addClass("hide");
    $("#additional_info2").remove();
    $("#additional_info3").remove();
    $("#additional_info4").remove();
    $("#additional_info5").remove();
    $("#additional_info6").remove();
    $("#additional_info7").remove();
    $("#additional_info8").remove();
    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper2").addClass("hide");
    $("#ProofWrapper3").addClass("hide");
    $("#ProofWrapper4").addClass("hide");
    $("#ProofWrapper5").addClass("hide");
    $("#ProofWrapper6").addClass("hide");
    $("#ProofWrapper7").addClass("hide");
    $("#ProofWrapper8").addClass("hide");
    $("#ProofWrapper9").addClass("hide");
    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_2").remove();
    $("#customization_3").remove();

    $("#customization_img_2").remove();
    $("#customization_img_3").remove();

    $("#customization_imgText_2").remove();
    $("#customization_imgText_3").remove();

    $("#custom_text_map2").remove();
    $("#custom_text_map3").remove();

    $("#custom_text2").remove();
    $("#custom_text3").remove();

    $("#customization_text_4").remove();
    $("#customization_text_5").remove();
    $("#customization_text_6").remove();
    $("#customization_text_7").remove();
    $("#customization_text_8").remove();
    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
});

$(".check_radio_2").on("click", function () {
  if ($(this).val() == "yes") {
    $(".city_state3").removeClass("hide");
    $("#ProofWrapper3").removeClass("hide");
    if ($("#additional_info3").length === 0 && $(".city_state3").length > 0) {
      var html = `<input type="hidden" name="properties[City and State - 3]" value="" id="additional_info3">`;
      $(".hidden_properties").before(html);
    }
  } else {
    $(".city_state3").addClass("hide");

    $("#additional_info3").remove();
    $("#additional_info4").remove();
    $("#additional_info5").remove();
    $("#additional_info6").remove();
    $("#additional_info7").remove();
    $("#additional_info8").remove();
    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper3").addClass("hide");
    $("#ProofWrapper4").addClass("hide");
    $("#ProofWrapper5").addClass("hide");
    $("#ProofWrapper6").addClass("hide");
    $("#ProofWrapper7").addClass("hide");
    $("#ProofWrapper8").addClass("hide");
    $("#ProofWrapper9").addClass("hide");
    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_3").remove();

    $("#customization_img_3").remove();

    $("#customization_imgText_3").remove();

    $("#custom_text_map3").remove();

    $("#custom_text3").remove();

    $("#customization_text_4").remove();
    $("#customization_text_5").remove();
    $("#customization_text_6").remove();
    $("#customization_text_7").remove();
    $("#customization_text_8").remove();
    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
});

$(".check_radio_3").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state4").removeClass("hide");
    $("#ProofWrapper4").removeClass("hide");
    if ($("#customization_text_4").length === 0) {
      html += `<input type="hidden" name="properties[Customization 4]" value="" id="customization_text_4">`;
    }
    if ($("#additional_info4").length === 0 && $(".city_state4").length > 0) {
      var html4 = `<input type="hidden" name="properties[City and State - 4]" value="" id="additional_info4">`;
      $(".hidden_properties").before(html4);
    }
  } else {
    $(".city_state4").addClass("hide");

    $("#additional_info4").remove();
    $("#additional_info5").remove();
    $("#additional_info6").remove();
    $("#additional_info7").remove();
    $("#additional_info8").remove();
    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper4").addClass("hide");
    $("#ProofWrapper5").addClass("hide");
    $("#ProofWrapper6").addClass("hide");
    $("#ProofWrapper7").addClass("hide");
    $("#ProofWrapper8").addClass("hide");
    $("#ProofWrapper9").addClass("hide");
    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_4").remove();
    $("#customization_text_5").remove();
    $("#customization_text_6").remove();
    $("#customization_text_7").remove();
    $("#customization_text_8").remove();
    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_4").append(html);
});

$(".check_radio_4").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state5").removeClass("hide");
    $("#ProofWrapper5").removeClass("hide");
    if ($("#customization_text_5").length === 0) {
      html += `<input type="hidden" name="properties[Customization 5]" value="" id="customization_text_5">`;
    }
    if ($("#additional_info5").length === 0 && $(".city_state5").length > 0) {
      var html5 = `<input type="hidden" name="properties[City and State - 5]" value="" id="additional_info5">`;
      $(".hidden_properties").before(html5);
    }
  } else {
    $(".city_state5").addClass("hide");

    $("#additional_info5").remove();
    $("#additional_info6").remove();
    $("#additional_info7").remove();
    $("#additional_info8").remove();
    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper5").addClass("hide");
    $("#ProofWrapper6").addClass("hide");
    $("#ProofWrapper7").addClass("hide");
    $("#ProofWrapper8").addClass("hide");
    $("#ProofWrapper9").addClass("hide");
    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_5").remove();
    $("#customization_text_6").remove();
    $("#customization_text_7").remove();
    $("#customization_text_8").remove();
    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_5").append(html);
});

$("body").on("click", ".tm-toggle", function (event) {
  var div_id = $(this).closest(".custom_wrap").attr("id");
  $("#" + div_id + " .customization_body").toggleClass("hide");
});

$("input[name='customize_option_1']").on("click", function () {
  var $box = $(this);
  if ($box.is(":checked")) {
    var group = "input:checkbox[name='" + $box.attr("name") + "']";
    $(group).prop("checked", false);
    $box.prop("checked", true);

    var option_id = $(this).attr("id");

    var html = "";
    if ($("#customization_img_1").length === 0) {
      html += `<input type="hidden" name="properties[Customization 1]" value="" id="customization_img_1">`;
    }
    if ($("#customization_imgText_1").length === 0) {
      html += `<input type="hidden" name="properties[custom_ImageText_1]" value="" id="customization_imgText_1">`;
    }
    if (option_id == "text1") {
      $(".text_field1").removeClass("hide");
      $(".text_field11").removeClass("hide");
      $(".address_field1").addClass("hide");
      if ($("#customization_1").length > 0) {
        $("#customization_1").remove();
      }
      html += `<input type="hidden" name="properties[Please enter the custom text you'd like to add to your map 1:]" value="" id="custom_text_map1">
  <input
    type="hidden"
    name="properties[Please enter the location on the map where you would like your custom text to appear 1]"
    value=""
    id="custom_text1"
  >`;
    } else {
      $(".text_field1").addClass("hide");
      $(".text_field11").addClass("hide");
      $(".address_field1").removeClass("hide");
      if ($("#custom_text_map1").length > 0) {
        $("#custom_text_map1").remove();
        $("#custom_text1").remove();
      }
      if ($("#customization_1").length === 0) {
        html += ` <input
    type="hidden"
    name="properties[Please enter the location on the map where you would like this icon to appear 1:]"
    value=""
    id="customization_1"
  >`;
      }
    }

    $(".hidden_properties > .customization_1").append(html);

    var option_img1 = $(this).attr("data-src");
    $("#customization_img_1").val(option_img1);
    var option_imgalt1 = $(this).val();
    $("#customization_imgText_1").val(option_imgalt1);
  } else {
    $box.prop("checked", false);
    $(".text_field1").addClass("hide");
    $(".text_field11").addClass("hide");
    $(".address_field1").addClass("hide");
    $("#customization_1").remove();
    $("#customization_img_1").remove();
    $("#customization_imgText_1").remove();
    $("#custom_text1").remove();
    $("#custom_text_map1").remove();
  }
});

$("input[name='customize_option_2']").on("click", function () {
  var $box = $(this);
  if ($box.is(":checked")) {
    var group = "input:checkbox[name='" + $box.attr("name") + "']";
    $(group).prop("checked", false);
    $box.prop("checked", true);
    var option_id = $(this).attr("id");

    var html = "";

    if ($("#customization_img_2").length === 0) {
      html += `<input type="hidden" name="properties[Customization 2]" value="" id="customization_img_2">`;
    }
    if ($("#customization_imgText_2").length === 0) {
      html += `<input type="hidden" name="properties[custom_ImageText_2]" value="" id="customization_imgText_2">`;
    }

    if (option_id == "text2") {
      $(".text_field2").removeClass("hide");
      $(".text_field21").removeClass("hide");
      $(".address_field2").addClass("hide");
      if ($("#customization_2").length > 0) {
        $("#customization_2").remove();
      }
      html += `<input
    type="hidden"
    name="properties[Please enter the custom text you'd like to add to your map 2:]"
    value=""
    id="custom_text_map2"
  >
  <input
    type="hidden"
    name="properties[Please enter the location on the map where you would like your custom text to appear 2]"
    value=""
    id="custom_text2"
  >`;
    } else {
      $(".text_field2").addClass("hide");
      $(".text_field21").addClass("hide");
      $(".address_field2").removeClass("hide");

      if ($("#custom_text_map2").length > 0) {
        $("#custom_text_map2").remove();
        $("#custom_text2").remove();
      }
      if ($("#customization_2").length === 0) {
        html += ` <input
    type="hidden"
    name="properties[Please enter the location on the map where you would like this icon to appear 2:]"
    value=""
    id="customization_2"
  >`;
      }
    }

    $(".hidden_properties > .customization_2").append(html);

    var option_img2 = $(this).attr("data-src");
    $("#customization_img_2").val(option_img2);
    var option_imgalt2 = $(this).val();
    $("#customization_imgText_2").val(option_imgalt2);
  } else {
    $box.prop("checked", false);
    $(".text_field2").addClass("hide");
    $(".text_field21").addClass("hide");
    $(".address_field2").addClass("hide");
    $("#customization_2").remove();
    $("#customization_img_2").remove();
    $("#customization_imgText_2").remove();
    $("#custom_text2").remove();
    $("#custom_text_map2").remove();
  }
});

$("input[name='customize_option_3']").on("click", function () {
  var $box = $(this);
  if ($box.is(":checked")) {
    var group = "input:checkbox[name='" + $box.attr("name") + "']";
    $(group).prop("checked", false);
    $box.prop("checked", true);
    var option_id = $(this).attr("id");

    var html = "";

    if ($("#customization_img_3").length === 0) {
      html += `<input type="hidden" name="properties[Customization 3]" value="" id="customization_img_3">`;
    }
    if ($("#customization_imgText_3").length === 0) {
      html += `<input type="hidden" name="properties[custom_ImageText_3]" value="" id="customization_imgText_3">`;
    }

    if (option_id == "text3") {
      $(".text_field3").removeClass("hide");
      $(".text_field31").removeClass("hide");
      $(".address_field3").addClass("hide");

      if ($("#customization_3").length > 0) {
        $("#customization_3").remove();
      }

      html += `<input
    type="hidden"
    name="properties[Please enter the custom text you'd like to add to your map 3:]"
    value=""
    id="custom_text_map3"
  >
  <input
    type="hidden"
    name="properties[Please enter the location on the map where you would like your custom text to appear 3]"
    value=""
    id="custom_text3"
  >`;
    } else {
      $(".text_field3").addClass("hide");
      $(".text_field31").addClass("hide");
      $(".address_field3").removeClass("hide");

      if ($("#custom_text_map3").length > 0) {
        $("#custom_text_map3").remove();
        $("#custom_text3").remove();
      }

      if ($("#customization_3").length === 0) {
        html += ` <input
    type="hidden"
    name="properties[Please enter the location on the map where you would like this icon to appear 3:]"
    value=""
    id="customization_3"
  >`;
      }
    }
    $(".hidden_properties > .customization_3").append(html);

    var option_img3 = $(this).attr("data-src");
    $("#customization_img_3").val(option_img3);
    var option_imgalt3 = $(this).val();
    $("#customization_imgText_3").val(option_imgalt3);
  } else {
    $box.prop("checked", false);
    $(".text_field3").addClass("hide");
    $(".text_field31").addClass("hide");
    $(".address_field3").addClass("hide");
    $("#customization_3").remove();
    $("#customization_img_3").remove();
    $("#customization_imgText_3").remove();
    $("#custom_text3").remove();
    $("#custom_text_map3").remove();
  }
});

$(".check_radio_5").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state6").removeClass("hide");
    $("#ProofWrapper6").removeClass("hide");
    if ($("#customization_text_6").length === 0) {
      html += `<input type="hidden" name="properties[Customization 6]" value="" id="customization_text_6">`;
    }
    if ($("#additional_info6").length === 0 && $(".city_state6").length > 0) {
      var html6 = `<input type="hidden" name="properties[City and State - 6]" value="" id="additional_info6">`;
      $(".hidden_properties").before(html6);
    }
  } else {
    $(".city_state6").addClass("hide");

    $("#additional_info6").remove();
    $("#additional_info7").remove();
    $("#additional_info8").remove();
    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper6").addClass("hide");
    $("#ProofWrapper7").addClass("hide");
    $("#ProofWrapper8").addClass("hide");
    $("#ProofWrapper9").addClass("hide");
    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_6").remove();
    $("#customization_text_7").remove();
    $("#customization_text_8").remove();
    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_6").append(html);
});

$(".check_radio_6").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state7").removeClass("hide");
    $("#ProofWrapper7").removeClass("hide");
    if ($("#customization_text_7").length === 0) {
      html += `<input type="hidden" name="properties[Customization 7]" value="" id="customization_text_7">`;
    }
    if ($("#additional_info7").length === 0 && $(".city_state7").length > 0) {
      var html7 = `<input type="hidden" name="properties[City and State - 7]" value="" id="additional_info7">`;
      $(".hidden_properties").before(html7);
    }
  } else {
    $(".city_state7").addClass("hide");

    $("#additional_info7").remove();
    $("#additional_info8").remove();
    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper7").addClass("hide");
    $("#ProofWrapper8").addClass("hide");
    $("#ProofWrapper9").addClass("hide");
    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_7").remove();
    $("#customization_text_8").remove();
    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_7").append(html);
});

$(".check_radio_7").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state8").removeClass("hide");
    $("#ProofWrapper8").removeClass("hide");
    if ($("#customization_text_8").length === 0) {
      html += `<input type="hidden" name="properties[Customization 8]" value="" id="customization_text_8">`;
    }
    if ($("#additional_info8").length === 0 && $(".city_state8").length > 0) {
      var html8 = `<input type="hidden" name="properties[City and State - 8]" value="" id="additional_info8">`;
      $(".hidden_properties").before(html8);
    }
  } else {
    $(".city_state8").addClass("hide");

    $("#additional_info8").remove();
    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper8").addClass("hide");
    $("#ProofWrapper9").addClass("hide");
    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_8").remove();
    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_8").append(html);
});

$(".check_radio_8").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state9").removeClass("hide");
    $("#ProofWrapper9").removeClass("hide");
    if ($("#customization_text_9").length === 0) {
      html += `<input type="hidden" name="properties[Customization 9]" value="" id="customization_text_9">`;
    }
    if ($("#additional_info9").length === 0 && $(".city_state9").length > 0) {
      var html9 = `<input type="hidden" name="properties[City and State - 9]" value="" id="additional_info9">`;
      $(".hidden_properties").before(html9);
    }
  } else {
    $(".city_state9").addClass("hide");

    $("#additional_info9").remove();
    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper9").addClass("hide");
    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_9").remove();
    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_9").append(html);
});

$(".check_radio_9").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state10").removeClass("hide");
    $("#ProofWrapper10").removeClass("hide");
    if ($("#customization_text_10").length === 0) {
      html += `<input type="hidden" name="properties[Customization 10]" value="" id="customization_text_10">`;
    }
    if ($("#additional_info10").length === 0 && $(".city_state10").length > 0) {
      var html10 = `<input type="hidden" name="properties[City and State - 10]" value="" id="additional_info10">`;
      $(".hidden_properties").before(html10);
    }
  } else {
    $(".city_state10").addClass("hide");

    $("#additional_info10").remove();
    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper10").addClass("hide");
    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_10").remove();
    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_10").append(html);
});

$(".check_radio_10").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state11").removeClass("hide");
    $("#ProofWrapper11").removeClass("hide");
    if ($("#customization_text_11").length === 0) {
      html += `<input type="hidden" name="properties[Customization 11]" value="" id="customization_text_11">`;
    }
    if ($("#additional_info11").length === 0 && $(".city_state11").length > 0) {
      var html11 = `<input type="hidden" name="properties[City and State - 11]" value="" id="additional_info11">`;
      $(".hidden_properties").before(html11);
    }
  } else {
    $(".city_state11").addClass("hide");

    $("#additional_info11").remove();
    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper11").addClass("hide");
    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_11").remove();
    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_11").append(html);
});

$(".check_radio_11").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state12").removeClass("hide");
    $("#ProofWrapper12").removeClass("hide");
    if ($("#customization_text_12").length === 0) {
      html += `<input type="hidden" name="properties[Customization 12]" value="" id="customization_text_12">`;
    }
    if ($("#additional_info12").length === 0 && $(".city_state12").length > 0) {
      var html12 = `<input type="hidden" name="properties[City and State - 12]" value="" id="additional_info12">`;
      $(".hidden_properties").before(html12);
    }
  } else {
    $(".city_state12").addClass("hide");

    $("#additional_info12").remove();
    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#customization_text_12").remove();
    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();

    $("#ProofWrapper12").addClass("hide");
    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");
  }
  $(".hidden_properties > .customization_12").append(html);
});

$(".check_radio_12").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state13").removeClass("hide");
    $("#ProofWrapper13").removeClass("hide");
    if ($("#customization_text_13").length === 0) {
      html += `<input type="hidden" name="properties[Customization 13]" value="" id="customization_text_13">`;
    }
    if ($("#additional_info13").length === 0 && $(".city_state13").length > 0) {
      var html13 = `<input type="hidden" name="properties[City and State - 13]" value="" id="additional_info13">`;
      $(".hidden_properties").before(html13);
    }
  } else {
    $(".city_state13").addClass("hide");

    $("#additional_info13").remove();
    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper13").addClass("hide");
    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_13").remove();
    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_13").append(html);
});

$(".check_radio_13").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state14").removeClass("hide");
    $("#ProofWrapper14").removeClass("hide");
    if ($("#customization_text_14").length === 0) {
      html += `<input type="hidden" name="properties[Customization 14]" value="" id="customization_text_14">`;
    }
    if ($("#additional_info14").length === 0 && $(".city_state14").length > 0) {
      var html14 = `<input type="hidden" name="properties[City and State - 14]" value="" id="additional_info14">`;
      $(".hidden_properties").before(html14);
    }
  } else {
    $(".city_state14").addClass("hide");

    $("#additional_info14").remove();
    $("#additional_info15").remove();

    $("#ProofWrapper14").addClass("hide");
    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_14").remove();
    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_14").append(html);
});

$(".check_radio_14").on("click", function () {
  var html = "";
  if ($(this).val() == "yes") {
    $(".city_state15").removeClass("hide");
    $("#ProofWrapper15").removeClass("hide");
    if ($("#customization_text_15").length === 0) {
      html += `<input type="hidden" name="properties[Customization 15]" value="" id="customization_text_15">`;
    }
    if ($("#additional_info15").length === 0 && $(".city_state15").length > 0) {
      var html15 = `<input type="hidden" name="properties[City and State - 15]" value="" id="additional_info15">`;
      $(".hidden_properties").before(html15);
    }
  } else {
    $(".city_state15").addClass("hide");

    $("#additional_info15").remove();

    $("#ProofWrapper15").addClass("hide");

    $("#customization_text_15").remove();
  }
  $(".hidden_properties > .customization_15").append(html);
});
